(function(){
    'use strict';

    angular
    .module('app')
    .controller('MenusconfigController', MenusconfigController)
 
    MenusconfigController.$inject = ["$http","$timeout","$uibModal", "$log", "$document","$sce"];
        
    function MenusconfigController($http,$timeout,$uibModal, $log, $document,$sce)
    {                       
        var vm = this;
        vm.json = "";
        vm.limite = "0";
        vm.update = function(){
            var j = JSON.parse($('#fieldconfig-value').val());

        	console.log(vm.limit);
			
            j.references["limite"] = vm.limite;

			vm.scopeParent.$parent.fieldsVm.jsonValue = angular.toJson(j);
			$('#fieldconfig-value').val(vm.scopeParent.$parent.fieldsVm.jsonValue);
        }
        vm.init = function(scopeParent){
        	vm.scopeParent = scopeParent;
        	//console.log(scopeParent);
        	var valorJson = $('#fieldconfig-value').val();
        	if(valorJson!=""){
        		vm.json = JSON.parse(valorJson);
        		if(typeof vm.json.references.limite!='undefined'){
                    vm.limite = vm.json.references.limite;
                }
        	}
        	vm.update();
        }
    } 

})();